 // scroll bar
import 'simplebar/src/simplebar.css';
import posthog from 'posthog-js';
import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { Provider } from 'react-redux';
import { persistStore } from 'redux-persist';
import { PersistGate } from 'redux-persist/integration/react';
import { ProSidebarProvider } from 'react-pro-sidebar';
import { GoogleOAuthProvider } from '@react-oauth/google';
//
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
import reportWebVitals from './reportWebVitals';
import store from './store/index';
 
// ----------------------------------------------------------------------
 
const posthogKey = process.env.REACT_APP_POSTHOG_KEY;
const posthogHost = process.env.REACT_APP_POSTHOG_HOST;
 
localStorage.removeItem('force_posthog');
 
const isProduction =
  process.env.REACT_APP_ENV === 'prod' || window.location.hostname === 'app.keyskillset.com';
 
// ✅ FIX 1: Track initialization state
let posthogInitialized = false;
 
// ✅ FIX 2: Wrap entire PostHog init in try/catch so it NEVER crashes the app
if (posthogKey && posthogHost && isProduction) {
  try {
    posthog.init(posthogKey, {
      api_host: posthogHost,
      capture_pageview: true,
      capture_pageleave: true,
      // ✅ FIX 3: session_recording as a separate opt-in AFTER init
      // to avoid maskInputFn null iterator bug in some posthog-js versions
    });
    posthog.register({ environment: process.env.REACT_APP_ENV || 'unknown' });
    posthogInitialized = true;
  } catch (err) {
    // PostHog failure must NEVER crash the app
    console.warn('PostHog failed to initialize:', err.message);
  }
} else if (isProduction && (!posthogKey || !posthogHost)) {
  console.error(
    'REACT_APP_POSTHOG_KEY or REACT_APP_POSTHOG_HOST is missing - PostHog events will be missed.'
  );
}
 
// ✅ FIX 4: Both listeners guarded with posthogInitialized flag
window.addEventListener('error', (event) => {
  if (!posthogInitialized) return;
  posthog.capture('js_error', {
    message: event.message,
    filename: event.filename,
    lineno: event.lineno,
    colno: event.colno,
    stack: event.error?.stack || null,
    url: window.location.href,
  });
});
 
window.addEventListener('unhandledrejection', (event) => {
  if (!posthogInitialized) return;
  posthog.capture('js_error', {
    message: event.reason?.message || String(event.reason),
    stack: event.reason?.stack || null,
    url: window.location.href,
  });
});
 
// ----------------------------------------------------------------------

const persistor = persistStore(store);
const googleClientId = process.env.REACT_APP_WEB_CLIENT_ID;
 
const AppTree = (
<ProSidebarProvider>
<App />
</ProSidebarProvider>
);
 
ReactDOM.render(
<React.StrictMode>
<HelmetProvider>
<BrowserRouter>
<Provider store={store}>
<PersistGate loading={null} persistor={persistor}>
            {googleClientId ? (
<GoogleOAuthProvider clientId={googleClientId}>{AppTree}</GoogleOAuthProvider>
            ) : (
              AppTree
            )}
</PersistGate>
</Provider>
</BrowserRouter>
</HelmetProvider>
</React.StrictMode>,
  document.getElementById('root')
);
 
serviceWorker.unregister();
reportWebVitals();